import React from 'react'

type Props = {
  size?: number
}

export const ProfileIconAdd = ({ size = 20, ...props }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="5.5" y="9.5" width="9" height="1" rx="0.5" fill="#D9D9D9" />
      <rect
        x="9.5"
        y="14.5"
        width="9"
        height="1"
        rx="0.5"
        transform="rotate(-90 9.5 14.5)"
        fill="#D9D9D9"
      />
    </svg>
  )
}
